<template>
	<div>
		<layoutgrid v-if="item.l_pagetype=='layoutgrid'" :isgridexpand="false" :item="item" @layoutgridrollback="layoutgridrollback" @allcontrol="allcontrol"></layoutgrid>
		<layoutgrid v-if="item.l_pagetype=='layoutgrid_expand'" :isgridexpand="true" :item="item" @layoutgridrollback="layoutgridrollback" @allcontrol="allcontrol"></layoutgrid>
		<tabpage v-if="item.l_pagetype=='tabpage'" :item="item" @tabpagerollback="tabpagerollback" @allcontrol="allcontrol"></tabpage>
		<exportby_air v-if="item.l_pagetype=='exportby_air'" :item="item" :urlparam="urlparam"></exportby_air>
		<checkweight v-if="item.l_pagetype=='checkweight'" :item="item" :urlparam="urlparam"></checkweight>
		<gonggao v-if="item.l_pagetype=='gonggao'" :item="item" :urlparam="urlparam"></gonggao>
		<createcwbill v-if="item.l_pagetype=='createcwbill'" :item="item" :urlparam="urlparam"></createcwbill>
		<createorder v-if="item.l_pagetype=='createorder'" :item="item" :urlparam="urlparam"/>
		<orderimport v-if="item.l_pagetype=='orderimport'" :item="item" :urlparam="urlparam" />
		<setbaojia ref="setbaojia" v-if="item.l_pagetype=='setbaojia'" :item="item" :urlparam="urlparam" />
		<!-- <flight v-if="item.l_pagetype=='flight'" :urlparam="urlparam" @flightcallback="flightcallback"></flight> -->
		<showbaojia v-if="item.l_pagetype=='showbaojia'" :urlparam="urlparam"></showbaojia>
		<qgaccount v-if="item.l_pagetype=='qgaccount'" :item="item"  :urlparam="urlparam"></qgaccount>
		<supplierrate v-if="item.l_pagetype=='supplierrate'" :item="item"  :urlparam="urlparam"></supplierrate>
		<addmaininfo v-if="item.l_pagetype=='addmaininfo'" :item="item"  :urlparam="urlparam"></addmaininfo>
		<checkweightorder v-if="item.l_pagetype=='checkweight_order'" :item="item" :urlparam="urlparam"></checkweightorder>
		<tablegridcontrol v-if="item.l_pagetype=='tablegridcontrol'" :item="item" :urlparam="urlparam" ></tablegridcontrol>
		<erpinfo v-if="item.l_pagetype=='erpinfo'" :item="item"  :urlparam="urlparam"></erpinfo>
		<deviceparam v-if="item.l_pagetype=='deviceparam'" :item="item"  :urlparam="urlparam"></deviceparam>
		<addtaste v-if="item.l_pagetype=='addtaste'" :item="item"  :urlparam="urlparam"></addtaste>
		<addcargostuff v-if="item.l_pagetype=='addcargostuff'" :item="item"  :urlparam="urlparam"></addcargostuff>
		<addmeals v-if="item.l_pagetype=='addmeals'" :item="item"  :urlparam="urlparam"></addmeals>
		<returnexchange v-if="item.l_pagetype=='returnexchange'" :urlparam="urlparam" :item="item"></returnexchange>
		
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import returnexchange from '@/pages/packagemanage/createorder_returnexchange.vue'; //订单退货,换货,退换货
import addmeals from '@/pages/baseinfo/addmeals';
import addcargostuff from '@/pages/baseinfo/addcargostuff';
import addtaste from '@/pages/baseinfo/addtaste';
import deviceparam from '@/pages/baseinfo/deviceparam';
import tablegridcontrol from '@/pages/publictool/tablegridcontrol';
import erpinfo from '@/pages/erp/erpinfo';
import checkweightorder from '@/pages/wm/checkweight_order';
import addmaininfo from '@/pages/publictool/addmaininfo';
import flight from '@/pages/transport/flight';
import supplierrate from '@/pages/erp/supplier_rate';
import showbaojia from '@/pages/transport/showbaojia';
import qgaccount from '@/pages/baseinfo/qgaccount';
import setbaojia from '@/pages/transport/set_baojia';
import checkweight from '@/pages/wm/checkweight';
import exportby_air from '@/pages/transport/exportby_air';
import tabpage from '@/pages/main/tabpage';
import desktop from '@/pages/index/desktop';
import createcwbill from '@/pages/cw/createcwbill';
import packagelist from '@/pages/packagemanage/packagelist';
import createorder from '@/pages/packagemanage/createorder_pkg';
//import orderinport from '@/pages/packagemanage/orderinport';
import orderimport from '@/pages/packagemanage/orderimport';
import orderdetail from '@/pages/packagemanage/orderdetail';
import rolelist from '@/pages/user/rolelist';
import addrole from '@/pages/user/addrole';
import userlist from '@/pages/user/index';
import inlist from '@/pages/wm/inlist';
import outlist from '@/pages/wm/outlist';
import trashlist from '@/pages/Trash/trashlist';
import logisticstrashlist from '@/pages/logisticsmanager/trashlist';
import orderlist from '@/pages/ordermanager/orderlist';
import routeorder from '@/pages/ordermanager/routeorder';
import logistics from '@/pages/logisticsmanager/logistics';
import createlogisticsorder from '@/pages/logisticsmanager/createlogisticsorder';
import cwscheme from '@/pages/cw/cwscheme';
import setscheme from '@/pages/cw/setscheme';
import vipcharge from '@/pages/cw/vipcharge';
import vipbill from '@/pages/cw/vipbill';
import userinfo from '@/pages/user/userinfo';
import createinternational from '@/pages/logisticsmanager/createinternational';
import vipchargemove from '@/pages/cw/vipcharge_move';
import createlogisticsorderbatch from '@/pages/logisticsmanager/createlogisticsorder_batch';
import createinternationalfedex from '@/pages/logisticsmanager/createinternational_fedex';
import orderpayshop from '@/pages/cw/orderpay_shop';
import orderpayzb from '@/pages/cw/orderpay_zb';
// import storageout from '@/pages/wm/storageout';
//import predictfee from '@/pages/cw/predictfee'; //预估费用
import myworklist from '@/pages/workorders/myworklist'; //客服管理-提交服务单
import handleworklist from '@/pages/workorders/handleworklist'; //客服管理-处理服务单
import workcontext from '@/pages/workorders/workcontext'; //新增服务单
import handlework from '@/pages/workorders/handlework'; //处理服务单
import baselist from '@/pages/baseinfo/baselist'; //基础资料
import chargepaybills from '@/pages/cw/chargepaybills'; //交易明细
import handlelog from '@/pages/workorders/handlelog'; //日志查询
import handlefeebook from '@/pages/cw/handlefeebook'; //操作记账
import addfeebook from '@/pages/cw/addfeebook'; //新增/修改操作记账
import myfeebook from '@/pages/cw/myfeebook'; //我的账单
import customerlist from '@/pages/crm/customerlist.vue'; //客户管理
import addcustomer from '@/pages/crm/addcustomer.vue'; //添加/修改客户
import customerdetail from '@/pages/crm/customer_detail'; //客户信息详情
import customertodeal from '@/pages/crm/customer_todeal'; //客户待处理事项列表
import shoplist from '@/pages/group/shoplist'; //门店管理列表
import setuser from '@/pages/group/setuser'; //设置门店人员
import collectpay from '@/pages/cw/collectpay'; //收款付款单列表
import addcollectpay from '@/pages/cw/addcollectpay'; //新增/修改 收款付款单
import collectpayreport from '@/pages/cw/collectpay_report';
import cargolist from '@/pages/baseinfo/cargolist';
import addcargo from '@/pages/baseinfo/addcargo';
import stock_inlist from '@/pages/stockmanager/stock_inlist';
import stock_outlist from '@/pages/stockmanager/stock_outlist';
import stock_out from '@/pages/stockmanager/stock_out';//验货出库
import stocklist from '@/pages/stockmanager/stocklist';
import stock_outlist_plan from '@/pages/stockmanager/stock_outlist_plan';
import haitaolist from '@/pages/haitaomananger/haitaolist';
import haitaocreateorder from '@/pages/haitaomananger/createorder_haitao';
import haitaotrashlist from '@/pages/haitaomananger/trashlist';
import wtjlist from '@/pages/wm/wtjlist';
import remindset from '@/pages/msg/remindset';
import harvestlist from '@/pages/wm/harvestlist';
import harvest from '@/pages/wm/harvest';
import storagein from '@/pages/wm/storagein';
import shelves from '@/pages/wm/shelves'; //上架
import shelveslist from '@/pages/wm/shelveslist'; //上架列表
import wtjin from '@/pages/wm/wtjin'; //问题件入库
import takephoto from '@/pages/index/takephoto'; //拍照
import orderrate from '@/pages/packagemanage/orderrate'; //计算费用
import shopcargosort from '@/pages/baseinfo/sortlist'; //商城的商品分类列表 
import brandlist from '@/pages/baseinfo/brandlist'; //商城的商品品牌列表 
import speclist from '@/pages/baseinfo/speclist'; //商城的商品规格列表
import index_banner from '@/pages/shop/index_banner'; //商城首页轮播图
import index_cargolist from '@/pages/shop/index_cargolist'; //商城首页商品列表
import index_topnav from '@/pages/shop/index_topnav'; //商城首页顶部商品导航列表
import scanprint from '@/pages/packagemanage/scanprint'; 
import cargotaxschemelist from '@/pages/baseinfo/cargotaxscheme_list'; 
import cargotaxscheme from '@/pages/baseinfo/cargotaxscheme'; 
import postallist from '@/pages/postalmananger/postallist'; //邮件包裹管理
import trashlistnew from '@/pages/Trash/trashlistnew'; //通用型回收站
import cargoshelves from '@/pages/wm/cargoshelves'; //商品上架
import stockinlistplan from '@/pages/stockmanager/stock_inlist_plan'; //入库计划单
import stockinplan from '@/pages/stockmanager/stock_in_plan'; //入库计划单列表
import createstockinfo from '@/pages/stockmanager/createstockinfo'; //仓库管理--入库\出库
import reportcargostock from '@/pages/report/cargostock'; //商品库存流水账
import cargostockwarning from '@/pages/report/cargostock_warning'; //商品预警
import stocktakinglist from '@/pages/stockmanager/stock_taking_list'; //盘点管理记录
import stocktaking from '@/pages/stockmanager/stock_taking'; //仓库商品盘点
import index_banner_sort from '@/pages/shop/index_banner_sort'; //商城首页商品分类导航列表
import index_banner_brand from '@/pages/shop/index_banner_brand'; //商城首页商品品牌导航列表
import printset from '@/pages/user/printset';
import layoutgrid from '@/pages/main/layoutgrid';
import gonggao from '@/pages/msg/gonggao';

export default {
	components: {
		returnexchange,
		addmeals,
		addcargostuff,
		addtaste,
		deviceparam,
		erpinfo,
		tablegridcontrol,
		checkweightorder,
		addmaininfo,
		supplierrate,
		qgaccount,
		showbaojia,
		flight,
		setbaojia,
		createcwbill,
		gonggao,
		checkweight,
		exportby_air,
		tabpage,
		layoutgrid,
		desktop,
		packagelist,
		createorder,
		rolelist,
		addrole,
		userlist,
		//orderinport,
		orderimport,
		//storageout,
		inlist,
		outlist,
		orderdetail,
		trashlist,
		orderlist,
		routeorder,
		logistics,
		createlogisticsorder,
		logisticstrashlist,
		cwscheme,
		setscheme,
		vipcharge,
		vipbill,
		userinfo,
		createinternational,
		vipchargemove,
		createlogisticsorderbatch,
		createinternationalfedex,
		orderpayshop,
		orderpayzb,
		//predictfee,
		myworklist,
		handleworklist,
		workcontext,
		handlework,
		baselist,
		chargepaybills,
		handlelog,
		handlefeebook,
		addfeebook,
		myfeebook,
		customerlist,
		addcustomer,
		customerdetail,
		customertodeal,
		shoplist,
		setuser,
		collectpay,
		addcollectpay,
		collectpayreport,
		cargolist,
		addcargo,
		stock_inlist,
		stock_outlist,
		stocklist,
		stock_out,
		stock_outlist_plan,//出库计划单列表
		//stock_out_plan, //出库计划单
		haitaolist,
		haitaocreateorder,
		haitaotrashlist,
		wtjlist,
		remindset,
		harvestlist,
		harvest,
		storagein,
		shelves,
		shelveslist,
		wtjin,
		takephoto,
		orderrate,
		shopcargosort,
		brandlist,
		speclist,
		index_banner,
		index_cargolist,
		index_topnav,
		scanprint,
		cargotaxscheme,
		cargotaxschemelist,
		postallist,
		trashlistnew,
		cargoshelves,
		stockinlistplan,
		stockinplan,
		createstockinfo,
		reportcargostock,
		cargostockwarning,
		stocktaking,
		stocktakinglist,
		index_banner_sort,
		index_banner_brand,
		printset
	},
	props: {
		urlparam: {
			type: Object,
			default:function(){
				return {};
			}
		},
		item: {
			type: Object,
			default:function(){
				return {};
			}
		},
		param: {
			type: Object,
			default:function(){
				return {};
			}
		}
	},
	mounted() {
		//console.log('controlcenter加载---'+this.item.l_id+'  '+this.$tool.formatdate());
		// debugger
		// this.init();
	},
	data() {
		return {
			//item:{}
		}
	},
	methods:{
		init(){
			//debugger
			
		},
		layoutgridrollback(e){
			//列表回调
			//debugger
		},
		tabpagerollback(e){
			//选项卡回调
		},
		allcontrol(e){
			//debugger
			this.$emit('allcontrol',e);
		},
		flightcallback(e){
			//debugger
			this.$refs.setbaojia.setflightdata(e);
		},
		controlcentercallback(e){
			//debugger
			this.$emit('controlcentercallback',e);
		}
	}
}
</script>

<style>
</style>
